// State for sistem akses transaction
export const REQUEST_STATE = "REQUEST_STATE";
export const REQUEST_PAGE_STATE = "REQUEST_PAGE_STATE";
export const REQUEST_DONE = "REQUEST_DONE";
export const SET_ERROR_STATE = "SET_ERROR_STATE";
export const SET_SUCCESS_STATE = "SET_SUCCESS_STATE";
export const RESET_STATUS_STATE = "RESET_STATUS_STATE";

//State for login
export const SET_LOGIN_STATE = "SET_LOGIN_STATE";

//State Register
export const RESET_REGISTER = "RESET_REGISTER";
export const SET_TOKEN_REGISTER = "SET_TOKEN_REGISTER";
export const SET_FINISH_REGISTER = "SET_FINISH_REGISTER";

//List Notif
export const SET_NOTIF_LIST = "SET_NOTIF_LIST";
export const REQ_NOTIF_LIST = "REQ_NOTIF_LIST";
export const SET_ERROR_REQ_NOTIF = "SET_ERROR_REQ_NOTIF";

//Loan
export const REQ_LOAN = "REQ_LOAN";
export const REQ_LOAN_DONE = "REQ_LOAN_DONE";
export const SET_LOAN_LIST = "SET_LOAN_LIST";

// Detail Loan
export const REQ_DETAIL_LOAN = "REQ_DETAIL_LOAN";
export const REQ_DETAIL_LOAN_DONE = "REQ_DETAIL_LOAN_DONE";
export const SET_DETAIL_LOAN = "SET_DETAIL_LOAN";
export const SET_VA_LOAN = "SET_VA_LOAN";
export const SET_INFO_DOCS_LOAN = "SET_INFO_DOCS_LOAN";
export const SET_INFO_COLLATERAL_LOAN = "SET_INFO_COLLATERAL_LOAN";
export const SET_OFFERING_HISTORY = "SET_OFFERING_HISTORY";
export const SET_STATUS_HISTORY = "SET_STATUS_HISTORY";
export const SET_MEMO_HISTORY = "SET_MEMO_HISTORY";
export const SET_DIGISIGN_CHECK = "SET_DIGISIGN_CHECK";

//Negosiasi
export const REQ_NEGOSIASI = "REQ_NEGOSIASI";
export const REQ_NEGOSIASI_DONE = "REQ_NEGOSIASI_DONE";
export const SET_SUCCESS_NEGOSIASI = "SET_SUCCESS_NEGOSIASI";
export const SET_ERROR_NEGOSIASI = "SET_ERROR_NEGOSIASI";

//LoanAgreement
export const REQ_LOAN_AGREEMENT = "REQ_LOAN_AGREEMENT";
export const REQ_LOAN_AGREEMENT_DONE = "REQ_LOAN_AGREEMENT_DONE";
export const SET_SUCCESS_LOAN_AGREEMENT = "SET_SUCCESS_LOAN_AGREEMENT";
export const SET_ERROR_LOAN_AGREEMENT = "SET_ERROR_LOAN_AGREEMENT";
export const GET_DOCS_LOAN_AGREEMENT = "GET_DOCS_LOAN_AGREEMENT";

//Riwayat Transaksi
export const REQ_DISBURSE = "REQ_DISBURSE";
export const SET_DISBURSE_LIST = "SET_DISBURSE_LIST";
export const SET_ERROR_DISBURSE = "SET_ERROR_DISBURSE";

export const REQ_PAYMENT = "REQ_PAYMENT";
export const SET_PAYMENT_LIST = "SET_PAYMENT_LIST";
export const SET_ERROR_PAYMENT = "SET_ERROR_PAYMENT";

//DRAF PINJAMAN
export const REQ_TIPE_PINJAMAN = "REQ_TIPE_PINJAMAN";
export const SET_TIPE_PINJAMAN = "SET_TIPE_PINJAMAN";
export const SET_ERROR_TIPE_PINJAMAN = "SET_ERROR_TIPE_PINJAMAN";

export const REQ_TIPE_JAMINAN = "REQ_TIPE_JAMINAN";
export const SET_TIPE_JAMINAN = "SET_TIPE_JAMINAN";
export const SET_ERROR_TIPE_JAMINAN = "SET_ERROR_TIPE_JAMINAN";

//PROFILE
export const REQ_PROFILE = "REQ_PROFILE";
export const REQ_PROFILE_DONE = "REQ_PROFILE_DONE";
export const SET_PROFILE = "SET_PROFILE";

//Term And Condition
export const REQ_TNC = "REQ_TNC";
export const SET_TNC = "SET_TNC";
export const REQ_TNC_DONE = "REQ_TNC_DONE";
